import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m11.417 14.761-4.3-4.928c-.214-.246-.127-.579.195-.743a.863.863 0 0 1 .39-.09h8.597c.387 0 .701.24.701.536 0 .106-.041.21-.118.297l-4.299 4.928c-.214.247-.65.313-.972.149a.644.644 0 0 1-.194-.149Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ArrowSmallDownIcon24.js.map